import { render, staticRenderFns } from "./BaseHistorica.vue?vue&type=template&id=31eaa057&scoped=true"
import script from "./BaseHistorica.vue?vue&type=script&lang=js"
export * from "./BaseHistorica.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=31eaa057&prod&scoped=true&lang=css&external"
import style1 from "./BaseHistorica.vue?vue&type=style&index=1&id=31eaa057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eaa057",
  null
  
)

export default component.exports